<template>
  <div>
    <div v-show="login_show" :class="['login-wrapper', ['', 'login-form-right', 'login-form-left'][direction]]">
      <el-form ref="form" size="large" :model="form" :rules="rules" class="login-form ele-bg-white"
        @keyup.enter.native="doSubmit">
        <h4>{{ siteName || $t('login.title') }}</h4>
        <el-form-item prop="username">
          <el-input clearable v-model.trim="form.username" prefix-icon="el-icon-user"
            :placeholder="$t('login.username')" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input show-password v-model.trim="form.password" prefix-icon="el-icon-lock"
            :placeholder="$t('login.password')" />
        </el-form-item>
        <el-form-item v-if="captchaEnabled" prop="captcha">
          <div class="login-input-group">
            <el-input clearable v-model.trim="form.captcha" prefix-icon="el-icon-_vercode"
              :placeholder="$t('login.captcha')" />
            <img alt="" v-if="captcha" :src="captcha" @click="changeCode" class="login-captcha" />
          </div>
        </el-form-item>
        <el-form-item prop="google_token">
          <el-input v-model.trim="form.google_token" prefix-icon="el-icon-_vercode"
            :placeholder="$t('login.googleAuthenticator')" />
        </el-form-item>
        <div class="el-form-item">
          <el-button size="large" type="primary" class="login-btn" :loading="loading" @click="doSubmit">
            {{ loading ? $t('login.loading') : $t('login.login') }}
          </el-button>
        </div>
      </el-form>

      <div style="position: absolute;right: 30px;top: 20px;">
        <el-dropdown placement="bottom" @command="changeLanguage">
          <i class="el-icon-_language" style="font-size: 22px;color: #fff;cursor: pointer;"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="en">
              <span :class="{ 'ele-text-primary': language === 'en' }">English</span>
            </el-dropdown-item>
            <el-dropdown-item command="vi">
              <span :class="{ 'ele-text-primary': language === 'vi' }">Tiếng Việt</span>
            </el-dropdown-item>
            <el-dropdown-item command="zh_CN">
              <span :class="{ 'ele-text-primary': language === 'zh_CN' }">简体中文</span>
            </el-dropdown-item>
            <el-dropdown-item command="zh_TW">
              <span :class="{ 'ele-text-primary': language === 'zh_TW' }">繁體中文</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import setting from '@/config/setting';
import { fetchLoginIpAccess, isLoginIpAllowed, handleLoginAccessDenied } from '@/utils/login-ip';

export default {
  name: 'Login',
  data() {
    return {
      direction: 0,
      loading: false,
      form: {
        username: '',
        password: '',
        captcha: '',
        key: '',
        remember: true
      },
      captcha: '',
      captchaEnabled: true,
      siteName: '',
      login_show: false
    };
  },
  computed: {
    rules() {
      const rules = {
        username: [{
          required: true,
          message: this.$t('login.username'),
          type: 'string',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('login.password'),
          type: 'string',
          trigger: 'blur'
        }]
      };
      if (this.captchaEnabled) {
        rules.captcha = [{
          required: true,
          message: this.$t('login.captcha'),
          type: 'string',
          trigger: 'blur'
        }];
      }
      return rules;
    },
    language() {
      return this.$i18n.locale;
    }
  },
  mounted() {
    if (setting.takeToken()) {
      this.goHome();
    } else {
      this.verifyLoginAccess();
    }
  },
  methods: {
    verifyLoginAccess() {
      fetchLoginIpAccess()
        .then((res) => {
          if (isLoginIpAllowed(res)) {
            const data = (res.data && res.data.data) || {};
            this.applySiteName(data.site_name);
            this.login_show = true;
            this.changeCode();
          } else {
            handleLoginAccessDenied(res);
          }
        })
        .catch((e) => {
          if (e.response && e.response.status === 403) {
            handleLoginAccessDenied(e);
            return;
          }
          handleLoginAccessDenied(e);
          console.error('IP whitelist check failed:', e);
        });
    },
    applySiteName(name) {
      const siteName = (name || '').trim();
      if (!siteName) {
        return;
      }
      this.siteName = siteName;
      document.title = siteName;
    },
    doSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        this.$http.post('/login/login', this.form).then((res) => {
          if (res.data.code === 0) {
            this.$message.success('登录成功');
            this.$store.dispatch('user/setToken', {
              token: 'Bearer ' + res.data.data.access_token,
              remember: this.form.remember
            }).then(() => {
              this.goHome();
            });
          } else {
            this.$message.error(res.data.msg);
            if (this.captchaEnabled) {
              this.changeCode();
            }
          }
        }).catch((e) => {
          console.error(e);
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    goHome() {
      const query = this.$route.query;
      const path = query && query.from ? query.from : '/';
      this.$router.push(path).catch(() => {});
    },
    changeCode() {
      this.$http.get('/login/captcha').then((res) => {
        if (res.data.code === 0) {
          const data = res.data.data || {};
          this.captchaEnabled = data.enabled !== false;
          if (!this.captchaEnabled) {
            this.captcha = '';
            this.form.key = '';
            this.form.captcha = '';
            this.$nextTick(() => {
              if (this.$refs.form) {
                this.$refs.form.clearValidate();
              }
            });
            return;
          }
          this.captcha = data.captcha;
          this.form.key = data.key;
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.$refs.form.clearValidate();
            }
          });
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('i18n-lang', lang);
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  padding: 50px 20px;
  position: relative;
  box-sizing: border-box;
  background-image: url("~@/assets/bg-login.png");
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100vh;
}

.login-wrapper:before {
  content: "";
  background-color: rgba(0, 0, 0, .2);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.login-form {
  margin: 0 auto;
  width: 380px;
  max-width: 100%;
  padding: 25px 30px;
  position: relative;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  box-sizing: border-box;
  border-radius: 4px;
  z-index: 2;
}

.login-form-right .login-form {
  margin: 0 15% 0 auto;
}

.login-form-left .login-form {
  margin: 0 auto 0 15%;
}

.login-form h4 {
  text-align: center;
  margin: 0 0 25px 0;
}

.login-form > .el-form-item {
  margin-bottom: 25px;
}

.login-input-group {
  display: flex;
  align-items: center;
}

.login-input-group ::v-deep .el-input {
  flex: 1;
}

.login-captcha {
  height: 38px;
  width: 102px;
  margin-left: 10px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  text-align: center;
  cursor: pointer;
}

.login-captcha:hover {
  opacity: .75;
}

.login-btn {
  display: block;
  width: 100%;
}

@media screen and (min-height: 550px) {
  .login-form {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%);
    margin-top: -220px;
  }

  .login-form-right .login-form,
  .login-form-left .login-form {
    left: auto;
    right: 15%;
    transform: translateX(0);
    margin: -220px auto auto auto;
  }

  .login-form-left .login-form {
    right: auto;
    left: 15%;
  }
}

@media screen and (max-width: 768px) {
  .login-form-right .login-form,
  .login-form-left .login-form {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
    margin-right: auto;
  }
}
</style>
